var React = require('react');

function Stress (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.7263 1H14.7405C14.7029 1 14.6685 1.02109 14.6514 1.0546L1.0741 27.6967C1.0402 27.7632 1.08852 27.8421 1.1632 27.8421H11.2475C11.3185 27.8421 11.3669 27.9141 11.3401 27.9799L1.78097 51.4265C1.73811 51.5317 1.87582 51.6155 1.94959 51.5293L29.859 18.8808C29.9144 18.8159 29.8683 18.7158 29.783 18.7158H18.1416C18.0633 18.7158 18.0153 18.6299 18.0565 18.5632L28.8114 1.15255C28.8526 1.08593 28.8047 1 28.7263 1Z","stroke":"white","strokeWidth":"2","strokeLinejoin":"round"}));
}

Stress.defaultProps = {"width":"31","height":"53","viewBox":"0 0 31 53","fill":"none"};

module.exports = Stress;

Stress.default = Stress;
